import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Sites from './pages/Sites';
import SiteForm from './pages/SiteForm';
import FastlyServices from './pages/FastlyServices';
import DomainAnalyzer from './pages/DomainAnalyzer';
 
import Users from './pages/Users';
import UserForm from './pages/UserForm';
import AuditLogs from './pages/AuditLogs';
import Profile from './pages/Profile';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route
            path="domain-analyzer"
            element={
              <ProtectedRoute requireAnalyzerAccess>
                <DomainAnalyzer />
              </ProtectedRoute>
            }
          />
          <Route
            path="sites"
            element={
              <ProtectedRoute requireAdmin>
                <Sites />
              </ProtectedRoute>
            }
          />
          <Route
            path="sites/new"
            element={
              <ProtectedRoute requireAdmin>
                <SiteForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="sites/:id/edit"
            element={
              <ProtectedRoute requireAdmin>
                <SiteForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="fastly-services"
            element={
              <ProtectedRoute requireAdmin>
                <FastlyServices />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="users"
            element={
              <ProtectedRoute requireManagerOrAdmin>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="users/new"
            element={
              <ProtectedRoute requireManagerOrAdmin>
                <UserForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="users/:id/edit"
            element={
              <ProtectedRoute requireManagerOrAdmin>
                <UserForm />
              </ProtectedRoute>
            }
          />
          <Route path="audit" element={<AuditLogs />} />
          <Route path="profile" element={<Profile />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
